export enum CheckoutErrorCode {
    Unknown = 101,
    BuildOrderFailed = 125,
    PaymentStartFailed = 126,
    MissingCheckout = 127,
    RetailDeliveryCountryUnresolved = 128,
}
